type AxiosLikeError = {
  response?: unknown;
  code?: string;
  message?: string;
};

function isFetchNetworkFailureMessage(message: string): boolean {
  return (
    message === "Failed to fetch" ||
    message === "Load failed" ||
    message.includes("NetworkError when attempting to fetch resource")
  );
}

export function isRetryableNetworkError(error: unknown): boolean {
  const axiosError = error as AxiosLikeError | null;
  if (axiosError?.response) {
    return false;
  }

  if (
    axiosError?.code === "ERR_NETWORK" ||
    axiosError?.code === "ECONNABORTED" ||
    axiosError?.message === "Network Error"
  ) {
    return true;
  }

  let message = "";
  if (error instanceof Error) {
    message = error.message;
  } else if (typeof axiosError?.message === "string") {
    message = axiosError.message;
  }

  return isFetchNetworkFailureMessage(message);
}

export function waitForOnline(maxWaitMs: number): Promise<void> {
  if (typeof window === "undefined" || navigator.onLine) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    let settled = false;

    const finish = () => {
      if (settled) {
        return;
      }
      settled = true;
      window.removeEventListener("online", onOnline);
      clearTimeout(timeoutId);
      resolve();
    };

    const onOnline = () => {
      finish();
    };

    const timeoutId = setTimeout(finish, maxWaitMs);
    window.addEventListener("online", onOnline);
  });
}
